import { memo } from "react";

import variables from "../../styles/_variables.module.scss";

const CloudUpload = () => (
  <svg width="41" height="37" viewBox="0 0 41 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1576_16208)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6044 7.32227C22.67 7.32199 23.7244 7.53974 24.7027 7.96213C25.681 8.38452 26.5626 9.00261 27.2931 9.77837C28.0237 10.5541 28.5878 11.4712 28.9507 12.4731C29.3137 13.475 29.4678 14.5405 29.4036 15.6042H29.4175L29.4158 17.7346C31.1976 17.7341 32.9114 18.4185 34.2028 19.6462C35.4942 20.8739 36.2643 22.551 36.3538 24.3306L36.3625 24.6778C36.3612 26.4588 35.6757 28.1711 34.4478 29.461C33.2199 30.751 31.5434 31.5199 29.7647 31.609L29.4175 31.6177H29.4158L29.4175 31.6298H20.7345V24.8185H25.0126L19 17.745L13.003 24.8202H17.2637L17.262 31.6298H8.58246C6.74044 31.6252 4.9753 30.8908 3.6736 29.5875C2.37191 28.2842 1.63974 26.5181 1.63745 24.6761C1.63776 23.0762 2.19048 21.5254 3.20218 20.2859C4.21389 19.0464 5.62252 18.1943 7.18999 17.8735C6.80455 16.8665 6.74109 15.7648 7.00837 14.7202C7.27565 13.6757 7.86049 12.7398 8.6822 12.0417C9.50392 11.3437 10.522 10.9178 11.596 10.8229C12.67 10.728 13.747 10.9687 14.6784 11.5118C15.3399 10.2474 16.3352 9.18834 17.5562 8.44973C18.7773 7.71112 20.1773 7.32118 21.6044 7.32227Z"
        fill={variables["foreground"]}
      />
    </g>
    <defs>
      <clipPath id="clip0_1576_16208">
        <rect width="34.7251" height="34.7251" fill="white" transform="translate(1.63745 2.11328)" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(CloudUpload);
